// ---------------------------------------------------------------------
// Palette AVI par sous-type — spec iter164l (2026-02-25).
//
// Chaque sous-type AVI (Validation, Accusé, Information) possède
// désormais une identité chromatique complète et cohérente qui se
// propage aux :
//   • Badges de statut (En attente, Partiel, Lue/Approuvée/Reçue…)
//   • Colonnes Kanban et cartes
//   • Tuiles KPI du haut (Envoyées / Reçues / En attente / Positive)
//
// Convention de nommage :
//   • main             : couleur principale de marque (= AVI_SUBTYPES[k].color)
//   • softIcon/softText : nuance douce pour statut « en attente »
//   • mediumIcon       : nuance médiane pour statut « partiel »
//   • positiveColor    : couleur du statut final positif du sous-type
//                         (approuvee / accusee / lue)
//   • sentTotalDarkBg  : fond sombre de la tuile totale « Envoyées »
//   • receivedTotalDarkBg : fond sombre de la tuile totale « Reçues »
//
// La sémantique universelle des statuts CRITIQUES est PRÉSERVÉE :
//   • Refusée   → rouge #F87171 partout
//   • Annulée   → gris #9CA3AF partout
//   • Approuvée (Validation) → vert #4ADE80 (approbation universelle)
// ---------------------------------------------------------------------

export const AVI_SUBTYPE_PALETTES = {
  validation: {
    main: "#8a8fe0",
    softIcon: "#a8adf0",
    softText: "#d0d3f5",
    mediumIcon: "#7679c0",
    // Approuvée reste verte universelle — plus lisible qu'un dégradé bleu.
    positiveColor: "#4ADE80",
    sentTotalDarkBg: "#2e2a63",
    receivedTotalDarkBg: "#3f3a80",
    kanbanWaitingColor: "#a8adf0",
    kanbanPartialColor: "#8a8fe0",
  },
  accuse: {
    main: "#F9A826",
    softIcon: "#FBC576",
    softText: "#FDDDAA",
    mediumIcon: "#F9A826",
    // Reçu = état positif final Accusé → même orange que la marque.
    positiveColor: "#F9A826",
    sentTotalDarkBg: "#7A3E0F",
    receivedTotalDarkBg: "#9c5518",
    kanbanWaitingColor: "#FBC576",
    kanbanPartialColor: "#F9A826",
  },
  information: {
    main: "#2a9a7a",
    softIcon: "#7ec3a8",
    softText: "#c2e2d5",
    mediumIcon: "#5eb094",
    // Lue = état positif final Information → vert plein #2a9a7a.
    positiveColor: "#2a9a7a",
    sentTotalDarkBg: "#0e3a2e",
    receivedTotalDarkBg: "#1a5c47",
    kanbanWaitingColor: "#7ec3a8",
    kanbanPartialColor: "#5eb094",
  },
};

/**
 * Retourne la palette d'un sous-type. Fallback : palette validation
 * (comportement par défaut, la Validation étant le sous-type historique).
 */
export function subtypePalette(subtype) {
  return AVI_SUBTYPE_PALETTES[subtype] || AVI_SUBTYPE_PALETTES.validation;
}

/**
 * Table d'override statuts par sous-type — consommée par AviStatusBadge
 * et le hovercard Info.
 * Chaque entrée retourne `{ color, textColor? }` — merge sur le meta
 * par défaut du badge (icône + label restent intacts).
 */
export const AVI_STATUS_OVERRIDES = {
  validation: {
    en_attente:      { color: "#a8adf0", textColor: "#d0d3f5" },
    partiel_repondu: { color: "#8a8fe0" },
    // approuvee / refusee / annulee gardent leur look d'origine.
  },
  accuse: {
    en_attente:      { color: "#FBC576", textColor: "#FDDDAA" },
    partiel_repondu: { color: "#F9A826" },
    accusee:         { color: "#F9A826" },
    // annulee garde gris.
  },
  information: {
    en_attente:      { color: "#7ec3a8", textColor: "#c2e2d5" },
    partiel_repondu: { color: "#5eb094" },
    lue:             { color: "#2a9a7a" },
    // annulee garde gris.
  },
};
